module.exports = __webpack_public_path__ + "img/certificado.8dbe83b3.webp";